import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { getAuth, signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { app } from "../firebase";
import logoDark from "../../logo1.png";
import logoLight from "../../white1.png";
import image1 from "./img3.jpg";
import FacebookIcon from "@material-ui/icons/Facebook";
import { FaGoogle } from "react-icons/fa";

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const LoginForm = ({ isDarkMode }) => { // Receive setErrorMessage from parent component
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [errorMessage, setErrorMessage] = useState("");// Define errorMessage state variable
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const loginWithGoogle = () => {
        signInWithPopup(auth, googleProvider)
            .then((result) => {
                const user = result.user;
                navigate("/");
            })
            .catch((error) => {
                console.error("Error logging in with Google:", error.message);
                setErrorMessage("Error logging in with Google: " + error.message);
            });
    };
    const loginWithFacebook = () => {
        signInWithPopup(auth, facebookProvider)
            .then((result) => {
                const user = result.user;
                navigate("/");
            })
            .catch((error) => {
                console.error("Error logging in with Facebook:", error.message);
                setErrorMessage("Error logging in with Facebook: " + error.message);
            });
    };

    const login = async () => {
        try {
            const adminEmail = "moeezjavedmj@gmail.com";
            const adminPassword = "iladevaj29.";

            // Check if the entered credentials match admin credentials
            if (
                formData.email.toLowerCase() === adminEmail &&
                formData.password === adminPassword
            ) {
                // Admin login successful
                alert("Admin login successful");
                navigate("/scholarship"); // Redirect to admin panel route
                return; // Exit the function to prevent regular user login
            }

            // Attempt to log in the user
            await signInWithEmailAndPassword(auth, formData.email, formData.password);
            navigate("/"); // Redirect to home page after successful login
        } catch (error)
        {
            console.error("Error logging in:", error.message);
            // List of error codes to display to users
            const allowedErrorCodes = ["auth/wrong-password", "auth/user-not-found"];
            if (allowedErrorCodes.includes(error.code)) {
                setErrorMessage("Wrong credentials. Please check your email and password.");
            } else {
                setErrorMessage("An unexpected error occurred. Please try again later.");
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        login();
    };

    const closeErrorMessage = () => {
        setErrorMessage("");
    };

    const containerStyle = {
        backgroundImage: `url(${image1})`,
        backgroundSize: "cover",
        backgroundRepeat: "none",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        width: "100%",
    };

    return (
        <div style={containerStyle}>
            <div className={`formstyle {${isDarkMode ? 'dark-mode' : 'light-mode'}`} style={{ backgroundColor: isDarkMode ? '#333' : '#f8f9fa' ,      width: "300px",
                maxWidth: "480px",
                padding: "20px",
                borderRadius: "10px",
                marginRight: "-5%",}} >
                <div className="text-center mb-4">
                    {isDarkMode ? (
                        <img src={logoLight} alt="Dark Mode Logo" className="logo" style={{ width: "170px", height: "auto", marginLeft: "-1%" }}  />
                    ) : (
                        <img src={logoDark} alt="Light Mode Logo" className="logo1" style={{ width: "170px", height: "auto", marginLeft: "-1%" }}  />
                    )}
                </div>
                <h6 style={{ color: isDarkMode ? '#fff' : '#000', textAlign:"center", fontWeight: "bold", fontFamily: "cursive", marginTop:"-22%" ,fontSize:"0.55rem",marginLeft:"25%"  }}>Discover Scholarships & Opportunities</h6>
                <h2 className="title text-center" style={{marginLeft:"1%",marginTop:"5%"}}>Login</h2>
                {errorMessage && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {errorMessage}
                        <button type="button" className="btn-close" onClick={closeErrorMessage} aria-label="Close"></button>
                    </div>
                )}

                <form className="form" onSubmit={handleSubmit}>
                    <div className="form-group row align-items-center">
                        <label htmlFor="email" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Email
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                onChange={(e) => handleInputChange(e)}
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type="text"
                                name="email"
                                placeholder="Enter your email"
                                value={formData.email}
                                required
                                style={{
                                    width: "98%",
                                    height: "42px",
                                    padding: "6px 12px",
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                        </div>

                    </div>
                    <div className="form-group row align-items-center">
                        <label htmlFor="password" className="form-label col-sm-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                            Password
                        </label>
                        <div className="input-group col-sm-9">
                            <input
                                onChange={(e) => handleInputChange(e)}
                                className={`form-control ${isDarkMode ? '' : 'placeholder-color'}`}
                                type={showPassword ? "text" : "password"}
                                name="password"
                                placeholder="Enter your password"
                                value={formData.password}
                                required
                                style={{
                                    width: "89%",
                                    height: "42px",
                                    padding: "6px 12px",
                                    backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                                    color: isDarkMode ? '#000' : '#fff',
                                }}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm p-1"
                                type="button"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <FaEyeSlash size={12} /> : <FaEye size={12} />}
                            </button>
                        </div>

                        <br />
                    </div>
                    <button
                        className="btn btn-block mt-3 white"
                        type="button"
                        onClick={loginWithGoogle}
                        style={{
                            backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                            color: isDarkMode ? '#000' : '#fff',
                        }}
                    >
                        <FaGoogle style={{ width: "38px", marginRight: "10px" }} />
                        Login with Google
                    </button>

                    <button
                        className="btn btn-block mt-3 white"
                        type="button"
                        onClick={loginWithFacebook}
                        style={{
                            backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                            color: isDarkMode ? '#000' : '#fff',
                        }}
                    >
                        <FacebookIcon style={{ width: "20px", marginRight: "10px" }} />
                        Login with Facebook
                    </button>
                    <div>
                        <button className="btn btn-secondary btn-block mb-4" type="submit" style={{ backgroundColor: isDarkMode ? '#f8f9fa' : '#333',
                            color: isDarkMode ? '#000' : '#fff', marginTop:"25%"}}>
                            Submit
                        </button>
                    </div>
                </form>

                <p className="signup text-center mt-3" style={{color: isDarkMode ? '#fff' : '#000'}}>
                    No account?
                    <Link to="/">
                        <span className="fw-bold " style={{color: isDarkMode ? '#fff' : '#000'}}> Sign Up</span>
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default LoginForm;
